module.exports = "/_next/static/images/70ce731d80af80b2d9ffd888c12487f1-sanpablo-4.jpg.webp";